import Vue from "vue";
import VueI18n from 'vue-i18n';
import i18nEn from './i18n/en.json';
import i18nVi from './i18n/vi.json';
import App from "./App.vue";
import router from "./router";
import store from "./store";
import OddjobClient from "@/lib/oddjob-client";
// import firebaseConfig from "../config/firebaseConfig.json";
import firebaseConfig from "../config/firebasePro.json";
import * as firebase from 'firebase/app';

import VeeValidate, { Validator } from 'vee-validate';
import vi from 'vee-validate/dist/locale/vi';
import en from 'vee-validate/dist/locale/en';

firebase.initializeApp(firebaseConfig);
firebase.analytics();

Vue.config.productionTip = false;
Vue.use(VueI18n);
const oddjob = new OddjobClient();
Vue.prototype.$oddjob = oddjob;
store.$oddjob = oddjob;
// Vue.use(VueI18n);

Validator.localize({ vi: vi, en: en });

Vue.use(VeeValidate, {
    locale: (localStorage && localStorage.language) || 'en',
    dictionary: {
        vi: { attributes: vi },
        en: { attributes: en }
    }
});

const i18n = new VueI18n({
    locale: (localStorage && localStorage.language) || 'en',
    fallbackLocale: 'vi',
    messages: {
        'en': i18nEn,
        'vi': i18nVi
    }
});
// Vue.prototype.$i18n = i18n;

Vue.prototype.$analytics = firebase.analytics();


router.beforeEach((to, from, next) => {
    console.log("Router", to);
    firebase.analytics().setCurrentScreen(to.fullPath);
    firebase.analytics().logEvent(to.name);
    next();
});

new Vue({
    i18n,
    router,
    store,
    render: (h) => h(App),

    metaInfo: {
        changed(metaInfo) {
            console.log(metaInfo);
            firebase.analytics().setCurrentScreen(metaInfo.title);
            firebase.analytics().logEvent("page_view");
            firebase.analytics().logEvent("screen_view", {
                app_name: "oddjob-web",
                screen_name: metaInfo.title,
                app_version: "web-1.0"
            });
        }
    },
    mounted() {
        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                this.$analytics.setUserId(user.uid);
                this.$analytics.setUserProperties({
                    account_type: "web_basic" // can help you to define audiences
                });
            }
        });
    }
}).$mount("#app");




// export default {
// }


// let app;
// firebase.auth().onAuthStateChanged(function () {
//     if (!app) {
//         app = new Vue({
//             i18n,
//             router,
//             store,
//             render: (h) => h(App),
//         });
//         app.$mount('#app');
//     }
// });
